import { MOBILE_MAX_PX } from '@/constants/layout-breakpoints';
import { isMobileBrowser } from '@/utils/wallet-install';

/**
 * 客户端表面：布局断点（决定 H5/PC 壳与跳转）+ UA 粗分。
 * 两者可能不一致（窄窗 PC UA、宽屏手机等），排查显示/跳转问题很有用。
 *
 * @returns {{ platform: 'h5'|'pc', ua: 'mobile'|'desktop', viewportW?: number }}
 */
export function resolveAnalyticsClientSurface() {
  if (typeof window === 'undefined') {
    return { platform: 'pc', ua: 'desktop' };
  }
  const layoutMobile = window.matchMedia(`(max-width: ${MOBILE_MAX_PX}px)`).matches;
  const viewportW = Math.round(Number(window.innerWidth) || 0) || undefined;
  return {
    platform: layoutMobile ? 'h5' : 'pc',
    ua: isMobileBrowser() ? 'mobile' : 'desktop',
    viewportW,
  };
}
